var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAssignmentIndLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8761_19656)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 16.7C10 14.0925 12.0925 12 14.7 12H18.1V14.2H14.7C13.3075 14.2 12.2 15.3075 12.2 16.7V34.5C12.2 35.8925 13.3075 37 14.7 37H33.5C34.8925 37 36 35.8925 36 34.5V16.7C36 15.3075 34.8925 14.2 33.5 14.2H30.1V12H33.5C36.1075 12 38.2 14.0925 38.2 16.7V34.5C38.2 37.1075 36.1075 39.2 33.5 39.2H14.7C12.0925 39.2 10 37.1075 10 34.5V16.7Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 11.3C17 9.99249 17.9925 9 19.3 9H28.9C30.2075 9 31.2 9.99249 31.2 11.3V14.9C31.2 16.2075 30.2075 17.2 28.9 17.2H19.3C17.9925 17.2 17 16.2075 17 14.9V11.3ZM19.2111 11.2238C19.2075 11.2329 19.2 11.2567 19.2 11.3V14.9C19.2 14.9433 19.2075 14.9671 19.2111 14.9762C19.2131 14.981 19.2146 14.9836 19.2153 14.9847C19.2164 14.9854 19.219 14.9869 19.2238 14.9889C19.2329 14.9925 19.2567 15 19.3 15H28.9C28.9433 15 28.9671 14.9925 28.9762 14.9889C28.981 14.9869 28.9836 14.9854 28.9847 14.9847C28.9854 14.9836 28.9869 14.981 28.9889 14.9762C28.9925 14.9671 29 14.9433 29 14.9V11.3C29 11.2567 28.9925 11.2329 28.9889 11.2238C28.9869 11.219 28.9854 11.2164 28.9847 11.2153C28.9836 11.2146 28.981 11.2131 28.9762 11.2111C28.9671 11.2075 28.9433 11.2 28.9 11.2H19.3C19.2567 11.2 19.2329 11.2075 19.2238 11.2111C19.219 11.2131 19.2164 11.2146 19.2153 11.2153C19.2146 11.2164 19.2131 11.219 19.2111 11.2238Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1 21.5C23.0507 21.5 22.2 22.3506 22.2 23.4C22.2 24.4493 23.0507 25.3 24.1 25.3C25.1493 25.3 26 24.4493 26 23.4C26 22.3506 25.1493 21.5 24.1 21.5ZM20 23.4C20 21.1356 21.8356 19.3 24.1 19.3C26.3644 19.3 28.2 21.1356 28.2 23.4C28.2 25.6644 26.3644 27.5 24.1 27.5C21.8356 27.5 20 25.6644 20 23.4Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 32C17 30.5925 18.0925 29.5 19.5 29.5H28.7C30.1075 29.5 31.2 30.5925 31.2 32V35.4H29V32C29 31.8824 28.9594 31.815 28.9222 31.7778C28.885 31.7406 28.8176 31.7 28.7 31.7H19.5C19.3824 31.7 19.315 31.7406 19.2778 31.7778C19.2406 31.815 19.2 31.8824 19.2 32V35.4H17V32Z",
    fill: "#121619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8761_19656"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.2,
    height: 30.2,
    fill: "white",
    transform: "translate(10 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAssignmentIndLight);
export default __webpack_public_path__ + "static/media/icon_assignment_ind_light.71f909db.svg";
export { ForwardRef as ReactComponent };